// components
import { Title } from '../Title/Title';
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { useGdds } from 'utils/hooks/use-gdds';
import { useSectionId } from 'utils/hooks/use-section-id';
import { TitleFormats } from '../Title/title.types';

export type TableProps = {
  title: string;
  contentIndex: number;
  titleInAnchor: boolean;
  subtitle?: string;
  anchor?: string;
  table?: string;
  border?: string;
  isSectionReference?: boolean;
};

export function Table({
  title,
  anchor,
  border,
  subtitle,
  table,
  contentIndex,
  titleInAnchor,
  isSectionReference,
}: Readonly<TableProps>) {
  const isGdds = useGdds();
  const sectionId = useSectionId(title, anchor ?? '', titleInAnchor, contentIndex);
  const borderClass = border === 'disable-border' ? `c-table--${border}` : '';

  return (
    <div className="grid-container" id={sectionId}>
      <div className={`c-table ${borderClass}`}>
        <Title
          title={title}
          subtitle={subtitle}
          Format={isGdds ? TitleFormats.h3 : TitleFormats.h2}
          titlePreviewId="#st_title"
          subtitlePreviewId="#st_subtitle"
          isSectionReference={isSectionReference}
          formatClassName={isGdds ? undefined : 'h3'}
        />
        <InnerHtml as="div" content={table} />
      </div>
    </div>
  );
}
